import { Text as TextC, TextProps } from '@chakra-ui/react';

export function Label(props: TextProps) {
  return <TextC color="#747474" fontWeight={500} fontFamily={'Glory'} fontSize={20} {...props} />;
}
